import React from 'react';
import styled from 'styled-components';
import { COLOR_ACCENT, COLOR_BACKGROUND_BRIGHT, COLOR_DESCRIPTION, DEVICES } from '../../const';
import StrengthEventBannerMask from '../../assets/strength-event-banner-mask.png';

const Container = styled.div`
  position: relative;
  background-color: ${COLOR_BACKGROUND_BRIGHT};
  @media ${DEVICES.mobile} {
    padding: 72px 0;
  }

  @media ${DEVICES.tablet} {
    padding: 120px 0;
  }
`;

const Inner = styled.div`
  margin: auto;

  @media ${DEVICES.mobile} {
    display: block;
  }

  @media ${DEVICES.tablet} {
    display: flex;
    align-items: center;
  }

  @media ${DEVICES.large} {
    display: flex;
    max-width: 1200px;
    align-items: center;
  }
`;

const Mask = styled.div`
  background-image: url(${StrengthEventBannerMask});
  background-size: 100%;
  background-repeat: no-repeat;
  width: 100%;
  aspect-ratio: 1920 / 245;
  position: absolute;
  bottom: 0;
  left: 0;
`;

const Right = styled.div`
  padding: 2rem;
  position: relative;
  @media ${DEVICES.mobile} {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media ${DEVICES.tablet} {
    width: 50%;
  }

  @media ${DEVICES.large} {
    width: 50%;
  }
`;

const RightImg = styled.img`
  width: 100%;
  border-radius: 20px;
`;

const Left = styled.div`
  padding: 2rem;
  postiion: relative;
  @media ${DEVICES.mobile} {
  }

  @media ${DEVICES.tablet} {
    width: 50%;
  }

  @media ${DEVICES.large} {
    width: 50%;
  }
`;

const LeftHeading = styled.div`
  font-weight: 700;
  color: ${COLOR_ACCENT};

  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1.5rem;
  }

  @media ${DEVICES.laptop} {
  }
`;

const LeftTitle = styled.div`
  font-weight: 700;
  line-height: 1.3;

  @media ${DEVICES.mobile} {
    font-size: 2rem;
    margin-top: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1.5rem;
    margin-top: 1.5rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 2.25rem;
  }
`;

const LeftDescription = styled.div`
  margin-top: 2.5rem;
  color: ${COLOR_DESCRIPTION};
  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 0.8rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1rem;
  }
`;

const LeftDescriptionBold = styled.div`
  margin-top: 1rem;
  font-weight: 700;
  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 0.8rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1rem;
  }
`;

export default function StrengthEventBanner() {
  return (
    <Container>
      <Mask />
      <Inner>
        <Left>
          <LeftHeading>
            OUR FEATURES. 02
          </LeftHeading>
          <LeftTitle>
            캥거루짐 챌린지 이벤트
          </LeftTitle>
          <LeftDescription>
            캥거루짐 아이들을 대상으로 매월 챌린지 이벤트가 열립니다 <br />
            익숙하지 않은 동작으로, 두뇌에 새로운 자극을 줄 수 있는 동작들이
            아이들에게 챌린지 미션으로 나가게 될거에요
          </LeftDescription>
          <LeftDescriptionBold>
            도전적인 목표는 아이들에게 강한 동기부여를 줍니다 <br />
            그리고 아이들을 집중하는 모습이 쌓여 점차 성장하게 됩니다
          </LeftDescriptionBold>
        </Left>
        <Right>
          <RightImg src="https://kangaroo-edu-main.s3.ap-northeast-2.amazonaws.com/landing-page/home/strength_event.jpg" />
        </Right>
      </Inner>
    </Container >
  )
}
